import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import VehicleModal from '../components/VehicleModal'; // убедитесь, что путь корректный
import HeaderLogged from '../components/HeaderLogged';
import Footer from '../components/Footer';
import { useWizardFormId, withForm } from '../utils/wizardForm';
function VehiclesTax8849() {
  const { id } = useParams(); // company id
  const navigate = useNavigate();
  // Номер формы — из адреса этой вкладки (см. utils/wizardForm.js)
  const formId = useWizardFormId();

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [vehicles, setVehicles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Состояния для полей модального окна
  const [vin, setVin] = useState('');
  const [weight, setWeight] = useState('');
  const [logging, setLogging] = useState('');
  const [taxAmount, setTaxAmount] = useState(0);

  const weightToTax = {
    '5500-7500': 100,
    '7501-10000': 150,
    '10001-25000': 200,
    '25001-55000': 300,
    '55001-75000': 400,
    '75001-100000': 500,
  };

  const steps = [
    { id: 1, label: 'Tax & Form' },
    { id: 2, label: 'Vehicles Tax' },
    { id: 3, label: 'IRS Payment Options' },
    { id: 4, label: 'Form Summary' },
    { id: 5, label: 'Payment and IRS Submission' },
    { id: 6, label: 'IRS Confirmation' },
  ];
  const currentStep = 2; // Второй шаг: Vehicles Tax

  // Загрузка данных о компании
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`/api/companies/${id}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          throw new Error('Error loading company data');
        }
        setCompany(await res.json());
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [id]);

  // Загрузка транспортных средств, уже добавленных в форму
  useEffect(() => {
    const fetchVehiclesFromForm = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!formId) return; // useWizardFormId уже уводит на страницу компании
        const res = await fetch(`/api/form8849/${formId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          throw new Error('Error loading vehicles from form');
        }
        const data = await res.json();
        const vehicleIds = data.vehicles;
        const vehiclesDetails = await Promise.all(
          vehicleIds.map(async (vehicleId) => {
            const vehicleRes = await fetch(`/api/vehicles/${vehicleId}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            if (!vehicleRes.ok) {
              throw new Error(`Error loading vehicle details for ID ${vehicleId}`);
            }
            return vehicleRes.json();
          })
        );
        setVehicles(vehiclesDetails);
      } catch (error) {
        console.error(error);
      }
    };

    fetchVehiclesFromForm();
  }, [formId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#E4F2FF]">
        <p className="text-gray-700 text-lg">Loading...</p>
      </div>
    );
  }

  // Открытие / Закрытие модального окна
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setVin('');
    setWeight('');
    setLogging('');
    setTaxAmount(0);
  };

  const handleWeightChange = (e) => {
    const newWeight = e.target.value;
    setWeight(newWeight);
    setTaxAmount(weightToTax[newWeight] || 0);
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      // 1. Создаем транспортное средство
      const vehicleResponse = await fetch('/api/vehicles/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          vin,
          gross_vehicle_weight: weight,
          description: logging,
          taxable_weight: taxAmount,
          company: id,
        }),
      });

      if (!vehicleResponse.ok) {
        throw new Error('Error creating vehicle');
      }

      const createdVehicle = await vehicleResponse.json();

      // 2. id формы — из адреса этой вкладки
      if (!formId) {
        throw new Error('Form ID not found');
      }

      // 3. Отправляем запрос на добавление транспортного средства в форму
      const addVehicleResponse = await fetch(
        `/api/form8849/${formId}/add_vehicle/${createdVehicle.id}/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!addVehicleResponse.ok) {
        throw new Error('Error adding vehicle to form');
      }

      // 4. Обновляем локальное состояние с добавленным транспортным средством
      setVehicles((prev) => [...prev, createdVehicle]);
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };

  const handleContinueFiling = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!formId) {
        throw new Error('Form ID not found');
      }
      // Отправляем запрос для обновления информации о форме
      const response = await fetch(`/api/form8849/${formId}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          step: 3,
        }),
      });
      if (!response.ok) {
        throw new Error('Error updating form info');
      }
      // После успешного обновления переходим к следующему этапу
      navigate(withForm(`/company/${id}/file-form/irs-payment-options-8849`, formId));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <HeaderLogged />

      {/* Верхний бар этапов */}
      <div className="bg-white shadow p-4">
        <div className="flex flex-wrap justify-center gap-2">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`px-2 py-1 sm:px-4 sm:py-2 rounded border text-center text-xs sm:text-sm ${
                step.id === currentStep
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-gray-300 text-gray-700 border-gray-300'
              }`}
            >
              {step.label}
            </div>
          ))}
        </div>
      </div>

      {/* Основной контент */}
      <main className="flex-1 bg-[#E4F2FF] p-4 flex justify-center">
        <div className="bg-white rounded shadow p-4 sm:p-6 w-full max-w-5xl space-y-4">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <h1 className="text-2xl font-bold text-[#0F2C5E]">Vehicles Tax</h1>
            <button
              className="bg-[#0F2C5E] text-white px-4 py-2 rounded hover:bg-blue-900 transition w-full sm:w-auto mt-2 sm:mt-0"
              onClick={openModal}
            >
              Add Vehicles
            </button>
          </div>

          {/* Таблица транспортных средств */}
          <div className="overflow-x-auto">
            <table className="min-w-full border text-xs sm:text-sm">
              <thead className="bg-gray-100 border-b">
                <tr>
                  <th className="px-4 py-2 text-left">VIN</th>
                  <th className="px-4 py-2 text-left">Gross Vehicle Weight (lbs)</th>
                  <th className="px-4 py-2 text-left">Logging</th>
                  <th className="px-4 py-2 text-left">Tax Amount</th>
                </tr>
              </thead>
              <tbody>
                {vehicles.map((vehicle) => (
                  <tr key={vehicle.id} className="border-b">
                    <td className="px-4 py-2">{vehicle.vin}</td>
                    <td className="px-4 py-2">{vehicle.gross_vehicle_weight}</td>
                    <td className="px-4 py-2">{vehicle.description}</td>
                    <td className="px-4 py-2">${vehicle.taxable_weight}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button
            className="bg-[#0F2C5E] text-white px-4 py-2 rounded hover:bg-blue-900 transition w-full sm:w-auto"
            onClick={handleContinueFiling}
          >
            Continue Filing
          </button>
        </div>
      </main>

      {/* Модальное окно для добавления транспортного средства */}
      <VehicleModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSave={handleSave}
        vin={vin}
        setVin={setVin}
        weight={weight}
        handleWeightChange={handleWeightChange}
        weightToTax={weightToTax}
      />

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default VehiclesTax8849;
